<template>
  <div>
    <v-data-table v-model="payload.selection" :headers="headers"
      :must-sort="true"
      :hide-default-footer="payload.showNewFooter"
      :loading="payload.loading"
      :item-key="payload.list.id"
      :items="payload.list"
      :footer-props="getFooterItems()"
      @item-expanded="(item) => payload.onExpand(item) || false"
      :show-select="payload.showSelect"
      :show-expand="payload.expand"
      :single-expand="true"
      :expanded.sync="payload.expanded"
      :page.sync="payload.page"
      :search="!total ? search : undefined"
      :custom-sort="customSort"
      :server-items-length="total ? total : undefined"
      :options.sync="paginationMap" dense class="bordered--table main-list">
      <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
        <v-simple-checkbox :ripple="false" color="primary" :value="isSelected" @input="select($event)"></v-simple-checkbox>
      </template>
      <template v-slot:top>
        <template v-if="!payload.selection.length">
          <template class="mt-1">
            <v-layout row class="mx-auto pa-2" v-if="!payload.hasFilters">
              <v-flex sm8 xs4>
                <template v-if="!payload.isHideAdd">
                  <v-menu v-if="payload.isAddnewAsMenu && payload.addMenuActions" offset-y :close-on-content-click="true">
                    <template #activator="{ on, attrs }">
                      <v-btn height="35" class="px-5" v-on="on" v-bind="attrs" color="primary" dark id="newbtn">{{ $t('new') }}</v-btn>
                    </template>
                    <div :style="payload.isChecklist ? {height:'340px',maxWidth:'190px'} : ''" :class="payload.isChecklist ? 'apply-scroll' : ''">
                      <v-list dense>
                        <v-list-item-group>
                          <template v-for="(item, index) in payload.addMenuActions">
                            <v-list-item v-if="item.isShow" :key="index" @click="item.click ? item.click() : '';payload.isChecklist ? $emit('setProperty', item) : ''">
                              <v-list-item-action class="custom-list-view" v-if="item.icon">
                                <v-icon size="20">{{item.icon}}</v-icon>
                              </v-list-item-action>
                              <v-list-item-title>
                                {{ $t(item.label) }}
                              </v-list-item-title>
                            </v-list-item>
                          </template>
                        </v-list-item-group>
                      </v-list>
                    </div>
                  </v-menu>
                  <v-btn v-else color="primary" dark id="newbtn" @click="payload.addNewRoute">{{ $t('new') }}</v-btn>
                </template>
                <v-btn v-else-if="!payload.isHideAdd" color="primary" dark id="newbtn" @click="payload.addNewRoute">{{ $t('message.common.new') }}</v-btn>
                <v-btn v-else-if="payload.addClickHandler" color="primary" dark id="newbtn" @click="payload.addClickHandler">{{ $t('message.common.new') }}</v-btn>
              </v-flex>
              <v-flex sm4 xs8 v-if="!payload.isStock && !payload.hasFilters">
                <v-text-field v-if="payload.isccsheet" dense outlined clearable append-icon="search" @keyup.enter="searchList" @click:append="searchList" single-line v-model="search" :label="$t('message.common.search')" class="text-xs-right" id="searchbtn"></v-text-field>
                <v-text-field v-else-if="payload.isTicketGroup" dense outlined clearable append-icon="search" single-line v-model="search" :label="$t('message.common.search')" class="text-xs-right" id="searchbtn"></v-text-field>
                <v-text-field v-else dense outlined persistent-hint :hint="$t('message.common.searchTriggerHint')" clearable append-icon="search" @keyup.enter="searchList" @click:append="searchList" single-line v-model="search" :label="$t('message.common.search')" class="text-xs-right search-hint-padding" id="searchbtn"></v-text-field>
              </v-flex>
            </v-layout>
            <slot name="filterForm" v-if="payload.hasFilters"></slot>
          </template>
        </template>
        <v-toolbar v-else :elevation="!!payload.selection.length ? 5 : 0" :color="!!payload.selection.length ? 'primary' : 'white'">
          <v-slide-y-transition v-if="payload.selection.length">
            <v-btn icon @click="payload.selection = []">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-slide-y-transition>
          <v-slide-y-transition>
            <v-toolbar-title v-if="payload.selection.length">
              <div class="white--text">{{ `${payload.selection.length} selected` }}</div>
            </v-toolbar-title>
          </v-slide-y-transition>
          <v-spacer  v-if="payload.selection.length"></v-spacer>
          <template v-if="payload.selection.length">
            <v-slide-y-transition>
              <v-btn rounded @click="printIds" class="black--text mr-2" color="white" key="print" v-if="payload.isProductSelect">
                {{ $t('message.product.printLbl') }}
              </v-btn>
            </v-slide-y-transition>
            <v-slide-y-transition>
              <v-menu offset-y v-if="payload.isDeviation">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="grey" dark v-bind="attrs" v-on="on" class="mx-2 px-2">
                    <v-icon class="mr-1">mdi-file-export-outline</v-icon> {{$t('message.common.export')}} </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in listDownloadTypes" :key="index" @click="exportDeviationIds(item.value)">
                      <v-list-item-action>
                        <v-icon>{{ item.value === 'pdf' ? 'mdi-file-pdf-box' : 'mdi-microsoft-excel' }}</v-icon>
                      </v-list-item-action>
                      <v-list-item-content class="py-0">
                        <v-list-item-title v-text="item.text"></v-list-item-title>
                      </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-slide-y-transition>
            <v-slide-y-transition>
              <v-btn rounded @click="exportIds" class="black--text mr-2" color="white" key="export" :loading="payload.exportLoading" v-if="(payload.isProductSelect)">
                {{ $t('message.common.export') }}
              </v-btn>
            </v-slide-y-transition>
            <template v-if="payload.sync24seven">
              <v-slide-y-transition>
              <v-btn rounded @click="syncIds" class="black--text mr-2" color="white" key="syncTo24seven" v-if="showSyncBtn">
                {{ $t('message.invoice.syncTo24seven') }}
              </v-btn>
            </v-slide-y-transition>
            </template>
            <template v-if="payload.isOffer">
              <v-slide-y-transition>
                <v-btn rounded @click="invoiceEntries" class="black--text" color="white" key="invoice" v-if="showInvoice">
                  {{ $t('message.customer.invoice') }}
                </v-btn>
              </v-slide-y-transition>
              <v-slide-y-transition v-if="payload.isInvoice && !disableDelete">
                <v-btn rounded @click="deleteEntries" class="black--text" color="white" key="delete">
                  {{ $t('message.common.delete') }}
                </v-btn>
              </v-slide-y-transition>
            </template>
            <v-slide-y-transition v-else>
              <v-btn rounded @click="deleteEntries" class="black--text" color="white" key="delete" :disabled="disableDelete || (payload.isProductSelect ? !payload.isAdmin : false)">
                {{ $t('message.common.delete') }}
              </v-btn>
            </v-slide-y-transition>
          </template>
        </v-toolbar>
      </template>
      <template #[`item.${payload.editProp}`]="{ item }">
        <template>
          <router-link v-if="payload.editURL" :to="payload.editURL(item)">{{ item[payload.editProp] }}</router-link>
          <a v-else-if="payload.is_checklist" @click="payload.editHandler(item)" class="underline">{{ item[payload.editProp] }}</a>
          <a v-else @click="payload.editHandler(item.id)" class="underline">{{ item[payload.editProp] }}</a>
        </template>
      </template>
      <template #[`item.${payload.editProp1}`]="{ item }">
        <template>
          <!-- Deferred column: filled by a second request, so show a spinner until it lands.
               Only lists that set enrichmentLoading on their payload are affected. -->
          <v-progress-circular v-if="payload.enrichmentLoading && item[payload.editProp1] === null" size="12" width="2" indeterminate color="grey"></v-progress-circular>
          <router-link v-else-if="payload.editURL1 && payload.editProp1 === 'oncustomerorder' && +($formatter.replaceCommaWithDot(item[payload.editProp1])) > 0" :to="payload.editURL1(item)">{{ item[payload.editProp1] }}</router-link>
          <router-link v-else-if="payload.editURL1 && payload.editProp1 === 'order_number' && item[payload.editProp1]" :to="payload.editURL1(item)">{{ item[payload.editProp1] }}</router-link>
          <router-link v-else-if="payload.editURL1 && payload.editProp1 === 'deviation_title' && item[payload.editProp1]" :to="payload.editURL1(item)">{{ item[payload.editProp1] }}</router-link>
          <span v-else>{{ item[payload.editProp1] }}</span>
        </template>
      </template>
      <template #[`item.${payload.editProp2}`]="{ item }">
        <template>
          <v-progress-circular v-if="payload.enrichmentLoading && item[payload.editProp2] === null" size="12" width="2" indeterminate color="grey"></v-progress-circular>
          <router-link v-else-if="payload.editURL2 && payload.editProp2 === 'onorder' && +($formatter.replaceCommaWithDot(item[payload.editProp2])) > 0" :to="payload.editURL2(item)">{{ item[payload.editProp2] }}</router-link>
          <span v-else>{{ item[payload.editProp2] }}</span>
        </template>
      </template>
      <template #[`item.${payload.editProp3}`]="{ item }">
        <template>
          <v-progress-circular v-if="payload.enrichmentLoading && item[payload.editProp3] === null" size="12" width="2" indeterminate color="grey"></v-progress-circular>
          <router-link v-else-if="payload.editURL3 && payload.editProp3 === 'inproduction' && +($formatter.replaceCommaWithDot(item[payload.editProp3])) > 0" :to="payload.editURL3(item)">{{ item[payload.editProp3] }}</router-link>
          <span v-else>{{ item[payload.editProp3] }}</span>
        </template>
      </template>
      <!-- 'available' has no link behaviour, it just waits on the same second request -->
      <template #[`item.available`]="{ item }">
        <template>
          <v-progress-circular v-if="payload.enrichmentLoading && item.available === null" size="12" width="2" indeterminate color="grey"></v-progress-circular>
          <span v-else>{{ item.available }}</span>
        </template>
      </template>
      <template #[`item.${payload.editProp4}`]="{ item }">
        <template>
          <router-link v-if="payload.editURL4 && payload.editProp4 === 'ordernumber'" :to="payload.editURL4(item)">{{ item[payload.editProp4] }}</router-link>
          <span v-else>{{ item[payload.editProp4] }}</span>
        </template>
      </template>
      <template #[`item.source_ref_number`]="{ item }" v-if="payload.isOffer">
        <template v-if="item.related_orders">
          <router-link v-for="(record, index) in item.related_orders" :key="record.Id" :to="`/orders/edit/${record.Id}/view`">
            {{ record.Number }} {{ item.related_orders.length - 1 === index ? '' : ',' }}
          </router-link>
        </template>
      </template>
      <template #[`item.salesordernumber`]="{ item }" v-if="payload.isWarehouseOrder">
        <template v-if="item.salesordernumber && item.salesorderid">
          <router-link :to="`/orders/edit/${item.salesorderid}/view`">
            {{ item.salesordernumber }}
          </router-link>
        </template>
      </template>
      <template #[`item.${payload.statusColor}`]="{ item }">
        <template>
          <v-chip small :color="item[payload.applyColor] ? item[payload.applyColor] : 'primary'" :text-color="$_foreGroundColor(item[payload.applyColor])">  {{item[payload.statusColor]}}</v-chip>
        </template>
      </template>
      <!-- HAVE ONEDRIVE LINK ON CUSTOMER AND PRODUCT -->
      <template #[`item.${payload.onedriveProp}`]="{ item }">
        <template>
          <v-hover v-slot:default="{ hover }">
            <div>
              <router-link v-if="payload.editURL" :to="payload.editURL(item)">{{ item[payload.editProp] }}</router-link>
              <v-fade-transition>
                <v-icon v-if="hover && item.onedrive_link" small @click="navigateToOD(item.onedrive_link)">launch</v-icon>
              </v-fade-transition>
            </div>
          </v-hover>
        </template>
      </template>
      <template v-for="(field, index) in booleanItems" #[`item.${field}`]="{ item }">
        <v-icon class="font--style" :key="index"> {{ item[field] ? 'done' : 'clear' }} </v-icon>
      </template>
      <template v-slot:expanded-item="{ item, headers }">
        <td :colspan="headers.length">
          <template v-if="payload.expandHeader && payload.expandHeader.length > 0">
            <v-simple-table dense width="100%" class="dense_table bordered--table">
              <thead>
                <tr>
                  <th v-for="(headers, index) in payload.expandHeader" :key="index">{{headers.text}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(product, i) in item[payload.expandItem]" :key="i">
                  <td v-for="(headers, index) in payload.expandHeader" :key="index">{{product[`${headers.value}`] }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </template>
          <slot name="expand" v-else></slot>
        </td>
      </template>
      <template v-slot:[`item.color`]="{ item }">
        <v-chip small :color="item.color" v-if="item.color" :text-color="$_foreGroundColor(item.color)">{{ item.color }}</v-chip>
      </template>
      <template v-slot:[`item.status`]="{ item }" v-if="payload.isccsheet">
        {{ item.status_val }}
      </template>
      <template v-slot:[`item.createdon`]="{ item }" v-if="payload.isccsheet">
        <router-link v-if="payload.editURL" :to="payload.editURL(item)">
          {{ item.createdon_date }}
        </router-link>
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn icon v-for="(action, index) in payload.actionsList" text
          v-show="action.is_show(item)"
          class="pa-0 action--btns ml-1"
          :style="{ color: action.color ? action.color(item) : '' }"
          @click="action.click(item)" :key="index">
          <v-icon>{{ action.icon(item) }}</v-icon>
        </v-btn>
      </template>
      <template #[`item.actions1`]="{ item }">
        <v-btn icon v-for="(action, index) in payload.actionsList1" text
          v-show="action.is_show(item)"
          class="pa-0 action--btns ml-1"
          :style="{ color: action.color ? action.color(item) : '' }"
          @click="action.click(item)" :key="index">
          <v-icon>{{ action.icon(item) }}</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-card elevation="0" v-if="payload.showNewFooter">
      <v-layout class="ma-1">
        <span class="pa-1 d-flex align-center">
          <span class="font-weight-bold text-caption">
            {{$t('message.layout.totalCount')}} :
          </span>
          <v-progress-circular class="mx-2" :size="15" indeterminate color="primary" v-if="payload.totalLoading"></v-progress-circular>
          <a v-else class="ma-2 font-weight-bold text-caption" @click="getTotalCount" id="dataList_showcount_link">
            {{ payload.showCount ? total : $t('message.layout.show') }}
          </a>
        </span>
        <v-spacer></v-spacer>
        <span class="pa-1">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-chip class="ma-2 mr-0 rounded-0" color="#eceaea" label tile v-bind="attrs" v-on="on">
                <v-icon color="#888787">mdi-18px mdi-cog</v-icon>
                <span class="ml-1 caption">{{ pagination.itemsPerPage }} per page </span>
              </v-chip>
            </template>
            <v-list dense>
              <v-list-item v-for="(item, index) in paginationList.itemsPerPageOptions" :key="index" @click="changeItemsPerPage(item)">
                <v-list-item-title class="pa-0" >{{ item }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-chip outlined class="ma-2 ml-0 rounded-0 noHover" label style="border-left: 1px solid #cbc5c5;">
            <v-icon :disabled="pagination.page === 1 || payload.loading"  @click="pageNavigation('prev')" color="#716969"
              id="dataList_previousPage_btn">
              mdi-chevron-left
            </v-icon>
            <span class="caption mx-2" v-if="payload.list.length !== 0">{{ ((pagination.page * pagination.itemsPerPage) - pagination.itemsPerPage) + 1 }} - {{ ((pagination.page * pagination.itemsPerPage) - pagination.itemsPerPage) + payload.list.length }}</span>
            <v-icon @click="pageNavigation('next')" color="#716969" :disabled="!payload.hasNextPage || payload.loading"
              id="dataList_nextPage_btn">
              mdi-chevron-right
            </v-icon>
          </v-chip>
        </span>
      </v-layout>
    </v-card>
    <!-- USED TO EXPORT INVOICE TO NORDEA -->
    <v-dialog v-model="showEmailDialog" max-width="500px" persistent>
      <v-form ref="emailForm" onsubmit="return false;">
        <v-card>
          <v-card-title>
            {{$t('message.unimicro.sendReport')}}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt-4">
            <v-text-field outlined textarea :label="$t('message.invoice.invoiceEmail')" v-model="emailIds" :rules="$_requiredValidation" hide-details></v-text-field>
            <span>{{ $t('message.common.multiEmailHint') }}</span>
            <v-row class="ml-1">
              <v-checkbox dense :label="$t('message.common.copy_to_me')" v-model="isCopyToMe" hide-details color="primary"></v-checkbox>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="shareNordeaExport" :loading="nordeaLoading">{{$t('message.common.send')}}</v-btn>
            <v-btn color="error" @click.stop="showEmailDialog=false">{{$t('message.common.close')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: ['payload', 'pagination', 'total', 'headers'],
  model: {
    prop: 'pagination',
    event: 'change'
  },
  data () {
    return {
      showEmailDialog: false,
      sendLoader: false,
      emailIds: '',
      disableDelete: false,
      paginationList: {
        'itemsPerPageOptions': [10, 25, 50, 100, -1]
      },
      paginationMap: this.pagination,
      search: this.pagination && this.pagination.search ? this.pagination.search : '',
      booleanItems: [],
      isCompleted: false,
      showInvoice: false,
      showSyncBtn: false,
      nordeaLoading: false,
      settingsObj: {},
      actionType: 0,
      isNordea: false,
      isCopyToMe: true
    }
  },
  computed: {
    invoiceActions () {
      return [{
        text: this.$t('message.order.download'),
        value: 1
      }, {
        text: this.$t('message.customer.email'),
        value: 2
      }]
    },
    listDownloadTypes () {
      return [{
        text: 'PDF',
        value: 'pdf'
      }, {
        text: 'Excel',
        value: 'excel'
      }]
    }
  },
  watch: {
    paginationMap (newValue) {
      if (!this.$formatter.isEmptyObject(newValue)) {
        let pageValue = newValue.page
        if (this.pageCount === 1) {
          if (this.pagination.page && newValue.page <= 1 && newValue.page < this.pagination.page) pageValue = this.pagination.page
          else pageValue = newValue.page
        }
        const result = Object.assign({ ...this.paginationMap }, { search: this.search, page: pageValue, hideCount: false })
        if (!this.$formatter.isEmptyObject(newValue)) {
          if (result && result.itemsPerPage) {
            window.localStorage.setItem('pagination_count', result.itemsPerPage)
          }
          setTimeout(() => {
            this.$set(this.paginationMap, 'page', pageValue)
          }, 750)
          this.$emit('change', result)
          this.pageCount++
        }
      }
    },
    search (val) {
      if (!val) {
        let search = Object.assign({ ...this.paginationMap }, { search: val })
        this.$emit('change', search)
      }
    },
    'payload.selection' (val) {
      if (val) {
        if (this.payload.isOffer) {
          let selectedItems = this.payload.selection.map(x => x)
          if (selectedItems && selectedItems.length > 0) {
            let stateToInvoice = selectedItems.filter(x => x.status === 'to_invoice')
            if (stateToInvoice && stateToInvoice.length > 0) this.showInvoice = true
            else this.showInvoice = false
            if (this.payload.sync24seven) {
              let syncStatus = selectedItems.every(x => x.status.value === 'completed' && !x.syncedto24seven)
              if (syncStatus) this.showSyncBtn = true
              else this.showSyncBtn = false
            }
            if (this.payload.module === 'invoices') {
              this.getInvoiceSettings()
              const completed = selectedItems.filter(x => x.status.value === 'completed')
              const draftItems = selectedItems.filter(x => x.status.value === 'draft')
              if (draftItems && draftItems.length > 0) this.isCompleted = false
              else this.isCompleted = true
              if (completed.length > 0) this.disableDelete = true
              else this.disableDelete = false
            }
          }
        }
      }
    }
  },
  mounted () {
    this.getBoolItems()
    this.$eventBus.$on('closeExportMailDialog', () => {
      this.showEmailDialog = false
      this.emailIds = ''
      this.nordeaLoading = false
    })
  },
  methods: {
    getFooterItems () {
      if (this.payload.module === 'products') return { 'itemsPerPageOptions': [10, 25, 50, 100, 300] }
      else return { 'itemsPerPageOptions': [10, 25, 50, 100, 300, -1] }
    },
    getBoolItems () {
      let booleanList = this.headers ? this.headers.filter(x => x.isBoolean) : []
      this.booleanItems = booleanList.map(x => x.value)
    },
    deleteEntries () {
      let ids = this.payload.selection.map(x => x.id)
      let data = { module: this.payload.module, ids }
      this.$eventBus.$emit('deleteItems', data)
    },
    exportIds () {
      let ids = this.payload.selection.map(x => x.id)
      this.payload.export(ids)
    },
    exportDeviationIds (type) {
      let ids = this.payload.selection.map(x => x.id)
      this.payload.export(type, ids)
    },
    syncIds () {
      let ids = this.payload.selection.map(x => x.id)
      this.payload.sync(ids)
    },
    invoiceEntries () {
      let ids = this.payload.selection.filter(x => x.status === 'to_invoice').map(x => x.id)
      this.payload.changeState(ids)
    },
    printIds () {
      let list = this.payload.selection.map(x => x)
      this.payload.print(list)
    },
    navigateToOD (url) {
      window.open(url, '_blank')
    },
    openxLedgerHandler (action) {
      this.actionType = action
      if (action === 1) {
        this.exportToXledger('')
      } else if (action === 2) {
        this.isNordea = false
        this.showEmailDialog = true
        this.isCopyToMe = true
        this.emailIds = this.settingsObj.xledgeremail || ''
      }
    },
    exportToXledger (emailIds) {
      let ids = this.payload.selection.map(x => x.id)
      this.payload.xledger(ids, emailIds, this.actionType)
    },
    exportToNordea (emailIds) {
      let ids = this.payload.selection.map(x => x.id)
      let langs = this.payload.selection.map(x => x.customer_language)
      this.payload.nordea(ids, emailIds, '', langs, this.actionType)
    },
    openNordeaExportHandler (action) {
      this.actionType = action
      if (action === 1) {
        this.exportToNordea('')
      } else if (action === 2) {
        this.isNordea = true
        this.showEmailDialog = true
        this.isCopyToMe = true
        // this.emailIds = `${this.settingsObj.nordeaemail ? this.settingsObj.nordeaemail + ',' : ''}${process.env.VUE_APP_DEFAULT_NORDEA_MAILS}`
      }
    },
    customSort (items, index, isDesc) {
      if (this.payload.isccsheet) return this.$_customSorting(items, index[0], isDesc[0], ['createdon'], 'DD.MM.YYYY HH:mm')
      return items
    },
    getInvoiceSettings () {
      this.$_getSingleRecordHandler('invoicesettings')
        .then((result) => {
          if (result.data) this.settingsObj = result.data
        })
    },
    shareNordeaExport () {
      if (this.$refs.emailForm.validate() && this.emailIds) {
        if (this.emailIds) this.isValidEmail = true
        const getMailIDsString = this.emailIds
        const listOfMailIds = getMailIDsString.split(',')
        if (listOfMailIds.length > 0) {
          for (let i = 0; i < listOfMailIds.length; i++) {
            if (listOfMailIds[i]) {
              listOfMailIds[i] = listOfMailIds[i].trim()
              if (this.validEmail(listOfMailIds[i])) this.isValidEmail = false
              else this.isValidEmail = true
            }
          }
        }
        if (!this.isValidEmail) {
          const to = this.emailIds.split(',')
          if (this.isCopyToMe) {
            let currentUserMail = this.$store.state.userDetails ? this.$store.state.userDetails.email : ''
            if (currentUserMail) to.push(currentUserMail)
          }
          this.nordeaLoading = true
          if (this.isNordea) this.exportToNordea(to)
          else this.exportToXledger(to)
        } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    /* eslint-disable */
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    searchList () {
      let search = Object.assign({ ...this.paginationMap }, { search: this.search })
      this.$emit('change', search)
    },
    changeItemsPerPage (val) {
      if (this.pagination.itemsPerPage !== val) {
        this.paginationMap = { ...this.paginationMap, page: 1, itemsPerPage: val }
      }
    },
    pageNavigation (pageNavigateTo) {
      let newPage = pageNavigateTo === 'next' ? this.paginationMap.page + 1 : (pageNavigateTo === 'prev' ? this.paginationMap.page - 1 : 1)
      if (newPage <= 0) newPage = 1
      this.paginationMap = { ...this.paginationMap, page: newPage }
    },
    getTotalCount () {
      this.$emit('getTotalRecordsCount')
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('closeExportMailDialog')
  }
}
</script>
<style>
.action--btns.v-btn--icon.v-size--default {
  height: 25px !important;
  width: 25px !important;
}
.underline {
  text-decoration: underline;
}
</style>
